import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Client } from "../../clients/_types/client";
import { Case } from "./case";
import { Worker } from "../../workers/_types/worker";
import { User } from "../../users/_types/user";

export class CaseTreatment extends Resource {
    public override type = 'caseTreatments';

    @prop()
    public name!: string;

    @prop()
    public icon!: string;
    
    @prop()
    public backgroundColor!: string;

    @prop()
    public foregroundColor!: string;

    @prop()
    public isDefault: boolean = false;
}